import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_bf7ea612 from 'nuxt_plugin_plugin_bf7ea612' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_gtm_2386bbfa from 'nuxt_plugin_gtm_2386bbfa' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_vuesocialsharingplugin_6652c666 from 'nuxt_plugin_vuesocialsharingplugin_6652c666' // Source: ./vue-social-sharing-plugin.js (mode: 'all')
import nuxt_plugin_dayjsplugin_4b5f7f60 from 'nuxt_plugin_dayjsplugin_4b5f7f60' // Source: ./dayjs-plugin.js (mode: 'all')
import nuxt_plugin_amp_38c37242 from 'nuxt_plugin_amp_38c37242' // Source: ./amp.js (mode: 'all')
import nuxt_plugin_axios_9a9c7826 from 'nuxt_plugin_axios_9a9c7826' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_index_60648e41 from 'nuxt_plugin_index_60648e41' // Source: ./firebase/index.js (mode: 'all')
import nuxt_plugin_rollbarclient_640cf9ee from 'nuxt_plugin_rollbarclient_640cf9ee' // Source: ./rollbar-client.js (mode: 'all')
import nuxt_plugin_pluginrouting_0eb12bb9 from 'nuxt_plugin_pluginrouting_0eb12bb9' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_10c10256 from 'nuxt_plugin_pluginmain_10c10256' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_pluginclient_44ea535a from 'nuxt_plugin_pluginclient_44ea535a' // Source: ./content/plugin.client.js (mode: 'client')
import nuxt_plugin_pluginserver_434447db from 'nuxt_plugin_pluginserver_434447db' // Source: ./content/plugin.server.js (mode: 'server')
import nuxt_plugin_deviceplugin_2b9dc310 from 'nuxt_plugin_deviceplugin_2b9dc310' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_workbox_4f20f1c9 from 'nuxt_plugin_workbox_4f20f1c9' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_72974048 from 'nuxt_plugin_metaplugin_72974048' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_vuelidate_4345260a from 'nuxt_plugin_vuelidate_4345260a' // Source: ../plugins/vuelidate (mode: 'all')
import nuxt_plugin_jsonld_593ee954 from 'nuxt_plugin_jsonld_593ee954' // Source: ../plugins/jsonld (mode: 'all')
import nuxt_plugin_mobileDetect_2955dbbc from 'nuxt_plugin_mobileDetect_2955dbbc' // Source: ../plugins/mobileDetect.js (mode: 'client')
import nuxt_plugin_rudder_4a8bef51 from 'nuxt_plugin_rudder_4a8bef51' // Source: ../plugins/rudder.js (mode: 'client')
import nuxt_plugin_recaptcha_4dc33226 from 'nuxt_plugin_recaptcha_4dc33226' // Source: ../plugins/recaptcha.js (mode: 'client')
import nuxt_plugin_plugin_3e7f6b69 from 'nuxt_plugin_plugin_3e7f6b69' // Source: ./auth/plugin.js (mode: 'all')
import nuxt_plugin_authRedirects_814be084 from 'nuxt_plugin_authRedirects_814be084' // Source: ../plugins/authRedirects.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    return this.$root.$options.$nuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"robots","content":"max-image-preview:large\""},{"hid":"og:site_name","property":"og:site_name","content":"Tuhoon - تهون"},{"hid":"twitter:card","name":"twitter:card","content":"summary"},{"hid":"twitter:site","name":"twitter:site","content":"@tuhoonapp"},{"hid":"instagram:site","name":"instagram:site","content":"@tuhoonapp"},{"hid":"twitter:creator","name":"twitter:creator","content":"@tuhoonapp"},{"hid":"author","name":"author","content":"Tuhoon - تهون"},{"hid":"application-name","name":"application-name","content":"Tuhoon - تهون"},{"name":"apple-mobile-web-app-title","content":"Tuhoon - تهون"},{"hid":"msapplication-TileColor","name":"msapplication-TileColor","content":"#7DCFC4"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"https:\u002F\u002Ftuhoon.com\u002Fconsultations\u002Fimg\u002Ffavicon.ico?ver=382655"},{"rel":"apple-touch-icon","sizes":"180x180","href":"https:\u002F\u002Ftuhoon.com\u002Fconsultations\u002Fimg\u002Fapple-touch-icon.png?ver=382655"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"https:\u002F\u002Ftuhoon.com\u002Fconsultations\u002Fimg\u002Ffavicon-32x32.png?ver=382655"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"https:\u002F\u002Ftuhoon.com\u002Fconsultations\u002Fimg\u002Ffavicon-16x16.png?ver=382655"},{"rel":"preconnect","href":"https:\u002F\u002Fwww.gstatic.com"},{"rel":"preconnect","href":"https:\u002F\u002Fcdn.jsdelivr.net"},{"rel":"preconnect","href":"https:\u002F\u002Ftrack.tuhoon.com"},{"rel":"preload","href":"https:\u002F\u002Ftuhoon.com\u002Fconsultations\u002Ffonts\u002Fteshrin-regular.woff2","as":"font","type":"font\u002Fwoff2","crossorigin":"anonymous"},{"rel":"preload","href":"https:\u002F\u002Ftuhoon.com\u002Fconsultations\u002Ffonts\u002Fteshrin-bold.woff2","as":"font","type":"font\u002Fwoff2","crossorigin":"anonymous"},{"rel":"preload","href":"https:\u002F\u002Ftuhoon.com\u002Fconsultations\u002Ffonts\u002Fmahkamaty-icons.woff?3226","as":"font","type":"font\u002Fwoff","crossorigin":"anonymous"}],"style":[],"script":[{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.defer=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-KTMK2VP')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-KTMK2VP&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_bf7ea612 === 'function') {
    await nuxt_plugin_plugin_bf7ea612(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_2386bbfa === 'function') {
    await nuxt_plugin_gtm_2386bbfa(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesocialsharingplugin_6652c666 === 'function') {
    await nuxt_plugin_vuesocialsharingplugin_6652c666(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjsplugin_4b5f7f60 === 'function') {
    await nuxt_plugin_dayjsplugin_4b5f7f60(app.context, inject)
  }

  if (typeof nuxt_plugin_amp_38c37242 === 'function') {
    await nuxt_plugin_amp_38c37242(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_9a9c7826 === 'function') {
    await nuxt_plugin_axios_9a9c7826(app.context, inject)
  }

  if (typeof nuxt_plugin_index_60648e41 === 'function') {
    await nuxt_plugin_index_60648e41(app.context, inject)
  }

  if (typeof nuxt_plugin_rollbarclient_640cf9ee === 'function') {
    await nuxt_plugin_rollbarclient_640cf9ee(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_0eb12bb9 === 'function') {
    await nuxt_plugin_pluginrouting_0eb12bb9(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_10c10256 === 'function') {
    await nuxt_plugin_pluginmain_10c10256(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginclient_44ea535a === 'function') {
    await nuxt_plugin_pluginclient_44ea535a(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_434447db === 'function') {
    await nuxt_plugin_pluginserver_434447db(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_2b9dc310 === 'function') {
    await nuxt_plugin_deviceplugin_2b9dc310(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_4f20f1c9 === 'function') {
    await nuxt_plugin_workbox_4f20f1c9(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_72974048 === 'function') {
    await nuxt_plugin_metaplugin_72974048(app.context, inject)
  }

  if (typeof nuxt_plugin_vuelidate_4345260a === 'function') {
    await nuxt_plugin_vuelidate_4345260a(app.context, inject)
  }

  if (typeof nuxt_plugin_jsonld_593ee954 === 'function') {
    await nuxt_plugin_jsonld_593ee954(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_mobileDetect_2955dbbc === 'function') {
    await nuxt_plugin_mobileDetect_2955dbbc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_rudder_4a8bef51 === 'function') {
    await nuxt_plugin_rudder_4a8bef51(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_recaptcha_4dc33226 === 'function') {
    await nuxt_plugin_recaptcha_4dc33226(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_3e7f6b69 === 'function') {
    await nuxt_plugin_plugin_3e7f6b69(app.context, inject)
  }

  if (typeof nuxt_plugin_authRedirects_814be084 === 'function') {
    await nuxt_plugin_authRedirects_814be084(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, (err) => {
        // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
        if (!err._isRouter) return reject(err)
        if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
